// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1518bc22","239":"e60fb37a","455":"26e09b03","488":"a81189c2"}[chunkId] + ".chunk.js";
};